import Button from '@atlaskit/button';
import React from 'react';
import MediaServicesFitToPageIcon from '@atlaskit/icon/glyph/media-services/fit-to-page';
import MediaServicesActualSizeIcon from '@atlaskit/icon/glyph/media-services/actual-size';
import { colors } from '@atlaskit/theme';
import { ExpandToggleContainer } from './styled'; // Atlaskit doesn't provide a circle variation of the expand/collapse icons so we have to implement our own

var ExpandCircleIcon = function ExpandCircleIcon(_ref) {
  var isDisabled = _ref.isDisabled;
  return /*#__PURE__*/React.createElement(MediaServicesActualSizeIcon, {
    label: '',
    size: 'small',
    primaryColor: isDisabled ? "var(--ds-text-disabled, ".concat(colors.N50, ")") : "var(--ds-text-mediumEmphasis, ".concat(colors.N500, ")")
  });
};

var CollapseCircleIcon = function CollapseCircleIcon(_ref2) {
  var isDisabled = _ref2.isDisabled;
  return /*#__PURE__*/React.createElement(MediaServicesFitToPageIcon, {
    label: '',
    size: 'small',
    primaryColor: isDisabled ? "var(--ds-text-disabled, ".concat(colors.N50, ")") : "var(--ds-text-mediumEmphasis, ".concat(colors.N500, ")")
  });
};

export var BaseExpandToggle = function BaseExpandToggle(_ref3) {
  var expanded = _ref3.expanded,
      editorId = _ref3.editorId,
      isDisabled = _ref3.isDisabled,
      label = _ref3.label,
      onClick = _ref3.onClick;
  var Icon;

  if (expanded) {
    Icon = CollapseCircleIcon;
  } else {
    Icon = ExpandCircleIcon;
  }

  return /*#__PURE__*/React.createElement(ExpandToggleContainer, null, /*#__PURE__*/React.createElement(Button, {
    appearance: 'subtle',
    "aria-expanded": expanded,
    "aria-controls": editorId,
    "aria-label": label,
    isDisabled: isDisabled,
    spacing: 'none',
    onClick: onClick,
    iconBefore: /*#__PURE__*/React.createElement(Icon, {
      isDisabled: isDisabled
    })
  }));
};